import { render, staticRenderFns } from "./SalesReportViewType.vue?vue&type=template&id=87af5c10&"
import script from "./SalesReportViewType.vue?vue&type=script&lang=ts&"
export * from "./SalesReportViewType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports